module.exports = __webpack_public_path__ + "static/media/Grabbi_Risk_Free.e8cc0d32.png";